import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, NgZone, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { ShortMessage } from '../../../../models/dashboard';

@Component({
  selector: 'recent-messages',
  templateUrl: './recent-messages.component.html',
  styleUrls: ['./recent-messages.component.scss']
})
export class RecentMessagesComponent {
  @Input()
  public messages: ShortMessage[];
  @Input()
  public editable = false;

  @Output()
  public removeMessage = new EventEmitter<ShortMessage>();

  constructor() { }

  public onRemoveMessage(message: ShortMessage, e: Event) {
    this.removeMessage.emit(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer-home/recent-messages/recent-messages.component.ts